<mat-form-field appearance="outline" class="date-picker-field">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [matDatepicker]="picker"
    [placeholder]="placeholder"
    [value]="value"
    [disabled]="disabled"
    [required]="required"
    [min]="minDate"
    [max]="maxDate"
    (dateChange)="onDateChange($event.value)">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>

